export default __webpack_public_path__ + "static/media/guideToInstantCardhelpHighlight.3d788134.png";